/* eslint-disable no-unused-vars,no-undef */
const noOp = () => {};

export const removeReactSelectStyles = {
  clearIndicator: noOp,
  container: noOp,
  control: noOp,
  dropdownIndicator: noOp,
  group: noOp,
  groupHeading: noOp,
  indicatorsContainer: noOp,
  indicatorSeparator: noOp,
  input: noOp,
  loadingIndicator: noOp,
  loadingMessage: noOp,
  menu: noOp,
  menuList: noOp,
  menuPortal: noOp,
  multiValue: noOp,
  multiValueLabel: noOp,
  multiValueRemove: noOp,
  noOptionsMessage: noOp,
  option: noOp,
  placeholder: noOp,
  singleValue: noOp,
  valueContainer: noOp
};
